import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const navigate = useNavigate();


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickNewManagement = () => {
        
        // navigate si funcionó
        navigate('/juridico-arrendamientos-gestiones-form')
    }

    const handleClickInfoManagement = (idgestion, openingmode) => {
        
        // navigate si funcionó
        navigate(`/juridico-arrendamientos-gestiones-form/${openingmode}/${idgestion}`)
    }

  

    return Object.freeze({
        handleClickInfoManagement,
        handleClickNewManagement
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}